import { GenIcon } from 'react-icons';
export const MdCurrencyFlagAud = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_22524_12195)' },
            child: [
                {
                    tag: 'mask',
                    attr: {
                        id: 'mask0_22524_12195',
                        maskType: 'luminance',
                        maskUnits: 'userSpaceOnUse',
                        x: '0',
                        y: '0',
                        width: '24',
                        height: '24',
                    },
                    child: [
                        {
                            tag: 'path',
                            attr: {
                                d: 'M21.5183 4.70089C19.3218 1.84375 15.8731 0 12 0C8.1269 0 4.67825 1.84375 2.48437 4.70089C2.33316 4.89455 2.18726 5.09352 2.05196 5.29779C1.91402 5.49941 1.78404 5.70633 1.66201 5.91856C1.57977 6.05916 1.49753 6.20242 1.42325 6.34567C1.38345 6.41465 1.34632 6.48627 1.30918 6.5579C1.21102 6.74626 1.12083 6.93726 1.03329 7.13357C0.961665 7.29275 0.892687 7.45457 0.829019 7.61905C0.643322 8.09126 0.486804 8.57674 0.362121 9.07813C0.322329 9.2373 0.285192 9.39913 0.248052 9.56361C0.168468 9.95358 0.1048 10.3568 0.0650077 10.7601C0.0358268 11.0386 0.0172674 11.3172 0.00930898 11.601C0.00400336 11.7337 0.00134277 11.8663 0.00134277 11.9989C0.00134277 14.7447 0.927171 17.2755 2.48437 19.2996C4.6809 22.1541 8.12956 24.0005 12 24.0005C15.8705 24.0005 19.3218 22.1541 21.5157 19.2996C23.0755 17.2755 23.9987 14.7447 23.9987 11.9989C23.9987 9.25322 23.0755 6.72238 21.5183 4.69823V4.70089Z',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
                {
                    tag: 'g',
                    attr: { mask: 'url(#mask0_22524_12195)' },
                    child: [
                        {
                            tag: 'path',
                            attr: {
                                d: 'M21.5183 4.70089C19.3218 1.84375 15.8731 0 12 0C8.1269 0 4.67825 1.84375 2.48437 4.70089C2.33316 4.89455 2.18726 5.09352 2.05196 5.29779C1.91402 5.49941 1.78404 5.70633 1.66201 5.91856C1.57977 6.05916 1.49753 6.20242 1.42325 6.34567C1.38345 6.41465 1.34632 6.48627 1.30918 6.5579C1.21102 6.74626 1.12083 6.93726 1.03329 7.13357C0.961665 7.29275 0.892687 7.45457 0.829019 7.61905C0.643322 8.09126 0.486804 8.57674 0.362121 9.07813C0.322329 9.2373 0.285192 9.39913 0.248052 9.56361C0.168468 9.95358 0.1048 10.3568 0.0650077 10.7601C0.0358268 11.0386 0.0172674 11.3172 0.00930898 11.601C0.00400336 11.7337 0.00134277 11.8663 0.00134277 11.9989C0.00134277 14.7447 0.927171 17.2755 2.48437 19.2996C4.6809 22.1541 8.12956 24.0005 12 24.0005C15.8705 24.0005 19.3218 22.1541 21.5157 19.2996C23.0755 17.2755 23.9987 14.7447 23.9987 11.9989C23.9987 9.25322 23.0755 6.72238 21.5183 4.69823V4.70089Z',
                                fill: '#012169',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M13.8145 1.24559L10.5727 3.73676H13.8145V7.46537H10.5727L13.8145 9.95247V10.3758L10.021 7.46537H8.9333L13.7986 11.2021H12.175L7.72893 7.78287V11.2021H5.29896V7.78287L0.852839 11.2021H0.30636L5.17427 7.46537H4.08396L0.0119019 10.5915C0.0198603 10.156 0.0384196 9.72859 0.0676006 9.30118L2.46044 7.46537H0.250645C0.285132 7.213 0.322269 6.96469 0.364714 6.72046C0.489397 5.95113 0.645915 5.20215 0.831612 4.48167C0.895279 4.22929 0.964258 3.98099 1.03588 3.73676H2.46044L1.30912 2.85345C1.34625 2.74355 1.38074 2.63364 1.42318 2.52781L2.99896 3.74082H4.08927L1.66194 1.87245C1.78663 1.55088 1.91395 1.23338 2.0519 0.919945L5.3016 3.41518V0H7.73158V3.41518L12.1777 0H12.7189L7.85096 3.73676H8.94126L13.8092 0H13.8171V1.24559H13.8145Z',
                                fill: '#FFFFFF',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M4.08661 3.73552H2.9963L1.42053 2.52253C1.49481 2.29865 1.57704 2.07885 1.65928 1.86719L4.08661 3.73552Z',
                                fill: '#EF3827',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M8.93597 7.46484L13.7986 11.2015H13.8118V10.3752L10.0263 7.46484H8.93597Z',
                                fill: '#EF3827',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M7.84833 3.73667H8.94129L13.8066 0H12.7162L7.84833 3.73667Z',
                                fill: '#EF3827',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M5.17164 7.46484L0.303737 11.2015H-0.00134277C-0.00134277 10.9939 0.00131781 10.7904 0.00662344 10.5909L4.07869 7.46484H5.16899H5.17164Z',
                                fill: '#EF3827',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M13.8145 4.48167V6.72046H7.24346V11.2021H5.78441V6.72046H0.362061C0.486743 5.95113 0.643261 5.20215 0.828958 4.48167H5.78441V0H7.24346V4.48167H13.8145Z',
                                fill: '#EF3827',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M6.51132 17.6482L5.56161 18.6245L5.73403 17.2742L4.3811 17.1389L5.54304 16.4332L4.80025 15.2872L6.07891 15.7568L6.51132 14.4648L6.94371 15.7568L8.21972 15.2872L7.47959 16.4332L8.64418 17.1389L7.28859 17.2742L7.46102 18.6245L6.51132 17.6482Z',
                                fill: '#FFFFFF',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M16.5222 16.025L15.941 16.3224L16.2275 15.7358L15.6316 15.4686L16.2678 15.324L16.1047 14.6928L16.6139 15.1016L17.0075 14.5789L17.0062 15.2333L17.6589 15.2145L17.148 15.6194L17.5681 16.1186L16.9317 15.9722L16.8062 16.6128L16.5222 16.025Z',
                                fill: '#FFFFFF',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M15.9045 9.72114L15.3267 10.0169L15.6073 9.4311L15.0122 9.16141L15.6476 9.01929L15.4878 8.38643L15.9962 8.79772L16.3899 8.27506L16.386 8.92856L17.0421 8.90812L16.5303 9.31559L16.9512 9.81226L16.314 9.66831L16.1868 10.3056L15.9045 9.72114Z',
                                fill: '#FFFFFF',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M19.6202 6.79451L19.0391 7.09195L19.323 6.50447L18.7297 6.23814L19.3625 6.09517L19.2027 5.46231L19.7119 5.87109L20.1056 5.34844L20.1017 6.00193L20.757 5.98401L20.2452 6.39148L20.6661 6.88814L20.0297 6.74168L19.8992 7.38065L19.6202 6.79451Z',
                                fill: '#FFFFFF',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M21.7405 10.6491L21.1635 10.9508L21.4458 10.3599L20.8516 10.0961L21.4878 9.95149L21.3246 9.3203L21.8347 9.72655L22.2259 9.20307L22.227 9.85824L22.8763 9.84115L22.368 10.2469L22.788 10.7461L22.1525 10.5972L22.0236 11.2395L21.7405 10.6491Z',
                                fill: '#FFFFFF',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M19.3303 12.2473L18.9014 12.3663L19.1538 11.9978L18.9088 11.6273L19.3355 11.7481L19.6131 11.4048L19.6273 11.8461L20.043 12.008L19.6266 12.1565L19.6005 12.601L19.3303 12.2473Z',
                                fill: '#FFFFFF',
                            },
                            child: [],
                        },
                        {
                            tag: 'path',
                            attr: {
                                d: 'M12 0.5C18.3512 0.5 23.4999 5.64869 23.5 12C23.5 18.3514 18.3513 23.501 12 23.501C5.64874 23.501 0.5 18.3514 0.5 12C0.500145 5.64869 5.64883 0.5 12 0.5Z',
                                stroke: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_22524_12195' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '24',
                                height: '24',
                                rx: '12',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
